/* Gastrobariatrica Santa Fe - interacciones (version Shopify).
   El nav y el footer ahora son snippets de Liquid, no se inyectan aqui. */
(function () {
  function init() {
    var nav = document.getElementById('nav');
    var burger = document.getElementById('burger');
    var links = document.getElementById('links');
    if (!nav || !burger || !links) return;

    // marcar el enlace activo segun la ruta actual
    var path = location.pathname.replace(/\/$/, '') || '/';
    links.querySelectorAll('a').forEach(function (a) {
      var href = (a.getAttribute('href') || '').replace(/\/$/, '') || '/';
      if (href === path) a.classList.add('active');
    });

    // nav solido: las paginas internas tienen page-hero azul, arrancan solidas
    var alwaysSolid = !document.querySelector('.hero');
    function onScroll() { nav.classList.toggle('solid', alwaysSolid || window.scrollY > 40); }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    burger.addEventListener('click', function () {
      var open = links.classList.toggle('open');
      nav.classList.toggle('menuopen', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
    links.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        links.classList.remove('open');
        nav.classList.remove('menuopen');
        document.body.style.overflow = '';
      });
    });

    // aparicion al hacer scroll
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.rv:not(.in)').forEach(function (el) { io.observe(el); });

    // barra de cookies
    try {
      if (!localStorage.getItem('gsf-cookies')) {
        var bar = document.createElement('div');
        bar.className = 'cookie-bar';
        bar.innerHTML =
          '<p>Usamos cookies para mejorar tu experiencia y analizar el trafico del sitio. ' +
          'Al continuar navegando aceptas su uso. <a href="/pages/aviso-privacidad">Mas informacion</a>.</p>' +
          '<div class="cookie-actions">' +
          '<button class="btn btn-outline cookie-reject" type="button">Rechazar</button>' +
          '<button class="btn btn-primary cookie-accept" type="button">Aceptar</button>' +
          '</div>';
        document.body.appendChild(bar);
        requestAnimationFrame(function () { bar.classList.add('show'); });
        var close = function (choice) {
          localStorage.setItem('gsf-cookies', choice);
          bar.classList.remove('show');
          setTimeout(function () { bar.remove(); }, 400);
        };
        bar.querySelector('.cookie-accept').addEventListener('click', function () { close('accepted'); });
        bar.querySelector('.cookie-reject').addEventListener('click', function () { close('rejected'); });
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Al llegar con #ancla, saltar directo a la seccion. */
window.addEventListener('load', function () {
  if (!location.hash) return;
  var el;
  try { el = document.querySelector(location.hash); } catch (e) { return; }
  if (!el) return;
  requestAnimationFrame(function () { el.scrollIntoView({ behavior: 'auto', block: 'start' }); });
});
